let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aqfCd")).then(() => parcelRequire('6fKY8'));